import { GroupedService as NewGroupedService } from '@Services/types/service.types';
import { ServicesAction } from './ServicesReducer';

export const updateServiceQuantity = (rowId: string, quantity: number): ServicesAction => ({
  type: 'UPDATE_SERVICE_QUANTITY',
  payload: { rowId, quantity },
});

export const resetSelections = (): ServicesAction => ({
  type: 'RESET_SELECTIONS',
});

export const setServiceMetadata = (services: NewGroupedService[]): ServicesAction => ({
  type: 'SET_SERVICE_METADATA',
  payload: services,
});

export const setEarliestPossible = (timestamp: number | null): ServicesAction => ({
  type: 'SET_EARLIEST_POSSIBLE',
  payload: timestamp,
});

export const setSelectedDate = (date: string | null): ServicesAction => ({
  type: 'SET_SELECTED_DATE',
  payload: date,
});

export const setComment = (comment: string): ServicesAction => ({
  type: 'SET_COMMENT',
  payload: comment,
});

export const setCurrentStep = (
  step: 'selection' | 'checkout' | 'confirmation'
): ServicesAction => ({
  type: 'SET_CURRENT_STEP',
  payload: step,
});

export const resetStep = (): ServicesAction => ({
  type: 'RESET_STEP',
});
